"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var BuyRentSVG_1 = __importDefault(require("../../../../../components/Icons/EssentialTips/BuyRentSVG"));
var classnames_1 = __importDefault(require("classnames"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var react_router_dom_1 = require("react-router-dom");
var react_i18next_1 = require("react-i18next");
var Localization_1 = require("../../../../../constants/Localization");
var i18n_1 = __importDefault(require("../../../../../i18n"));
var BuyRent = function () {
    var t = react_i18next_1.useTranslation('common').t;
    return (react_1.default.createElement("div", { className: classnames_1.default('ui container equal width grid', styles_module_scss_1.default.grid_container) },
        react_1.default.createElement("div", { className: "sixteen wide mobile ten wide computer column" },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.context_box },
                react_1.default.createElement("div", { className: styles_module_scss_1.default.content_header },
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(BuyRentSVG_1.default, { size: "medium", type: "primary" })),
                    react_1.default.createElement("div", { className: styles_module_scss_1.default.text }, "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam"),
                    react_1.default.createElement("div", { className: styles_module_scss_1.default.button },
                        react_1.default.createElement(react_router_dom_1.Link, { to: "/" + Localization_1.SellPagePrefix[i18n_1.default.language].sell, className: "btn btn-primary" }, t('ESSENTIAL_TIPS.GO_TO_SEARCH_RESULT_PAGE'))))))));
};
exports.default = BuyRent;
